module.exports = __webpack_public_path__ + "media/images/official/special_exchange_02-e890dc28a05278bf739d2b03c64705eb.png";